import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { DesignCollectionReferencesList } from "./DesignCollectionReferencesList";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";

type DesignCollectionReferencesDrawerProps = {
  drawer: DrawerType;
  id: string;
};

export const DesignCollectionReferencesDrawer: React.FC<
  DesignCollectionReferencesDrawerProps
> = ({ drawer, id: designCollectionId }) => {
  const { t } = useTranslation();
  const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t("designs.actions.references.title")}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 0 }}
    >
      <DesignCollectionReferencesList designCollectionId={designCollectionId} />
    </Drawer>
  );
};
